export enum IndicatorColor {
  PRIMARY = "primary",
  NOTIFICATION = "notification"
}
